<div class="modal-container">
  <div class="text">Are you sure you want to delete the talent pool?</div>
  <div class="buttons-container">
    <button
      mat-raised-button
      class="sm no-button"
      (click)="close()"
    >NO</button>
    <button
      mat-raised-button
      class="sm save-btn"
      color="primary"
      (click)="removeTalentPool()"
    >YES</button>
  </div>

</div>
